import type { ModuleDefinition } from '../types';

export const suppliersModule: ModuleDefinition = {
  key: 'suppliers',
  milestone: 'M9',
  network: {
    path: 'suppliers',
    permission: ['supplier.read.network', 'network.read'],
    labelKey: 'suppliers',
  },
  tenant: {
    path: 'suppliers',
    permission: ['supplier.read', 'study.read'],
    labelKey: 'suppliers',
  },
  load: () => import('./SuppliersModule'),
};
